var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42HError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 56H15l-.753-8.274A2.5 2.5 0 0 1 16.737 45h6.525a2.5 2.5 0 0 1 2.49 2.726L25 56Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m26 54-.223.445A2.813 2.813 0 0 1 23.26 56h-6.523a2.812 2.812 0 0 1-2.516-1.555L14 54"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M45 56H35l-.753-8.274A2.5 2.5 0 0 1 36.737 45h6.525a2.5 2.5 0 0 1 2.49 2.726L44.999 56Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m46 54-.223.445A2.813 2.813 0 0 1 43.26 56h-6.523a2.812 2.812 0 0 1-2.516-1.555L34 54"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M29.5 16.5A2.5 2.5 0 0 1 27 19H15.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 15.5 4h14v12.5ZM47 16.5a2.5 2.5 0 0 1-2.5 2.5H33a2.5 2.5 0 0 1-2.5-2.5V4h14A2.5 2.5 0 0 1 47 6.5v10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M47 14V6.5A2.5 2.5 0 0 0 44.5 4h-29A2.5 2.5 0 0 0 13 6.5V14"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M13 24.5a1.5 1.5 0 0 1 1.5-1.5h31a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-31a1.5 1.5 0 0 1-1.5-1.5v-15Z"
})));
SvgRectangle42HError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42HError);
export default ForwardRef;